import type { interpretationDataGridWidgetSchema } from '@/entities/optimization-statistic'
import type { SRT_RowData } from '@/shared/components/master-table'
import type z from 'zod'

import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import {
	createSRTColumnHelper,
	MasterTable,
	useMasterReactTable,
} from '@/shared/components/master-table'

import { DataGridCellImpl } from './data-grid-cell'

const columnHelper = createSRTColumnHelper()
export default function DataGrid(
	props: z.infer<typeof interpretationDataGridWidgetSchema> & {
		options: Record<string, { label: string; value: string }[]>
	}
) {
	const { t } = useTranslation()

	const columns = useMemo(
		() =>
			(props?.columns || []).map((col: any) => {
				const meta = { ...(col.meta || {}) }
				const optionsKey = col.meta.optionsKey
				meta.options = optionsKey ? props.options[optionsKey] : []

				return columnHelper.accessor(col.accessorKey, {
					header: t(col.header, { ns: 'fields', defaultValue: col.header }),
					id: col.id,
					meta,
					Cell: ({ cell }) => <DataGridCellImpl cell={cell} tableMeta={meta} />,
				})
			}),
		[props?.columns]
	)
	const data = props?.data || []
	const table = useMasterReactTable<SRT_RowData>({
		columns,
		data,
		defaultColumn: {
			minSize: 28,
			size: Number.MAX_SAFE_INTEGER,
			maxSize: Number.MAX_SAFE_INTEGER,
		},
		layoutMode: 'grid',
		defaultRowHeight: 30,
		enableColumnActions: false,
	})

	return (
		<div className='border-base relative mb-4 flex flex-1 flex-col overflow-hidden rounded-lg border border-solid [&_table]:my-0!'>
			<MasterTable table={table} />
		</div>
	)
}
